import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Row, Col, Button, Table, Form, Input, Select} from 'antd'
import {toJS} from 'mobx'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('mappingManagementStore', 'apiManagementStore')
@observer
class FormModal extends Component {
  state = {}
  formRef = React.createRef()

  componentDidMount() {
  }

  render() {
    const {addModalVisible, handleCancel, mappingManagementStore, record, t} = this.props
    const {versionList} = mappingManagementStore
    return (
      <>
        <Modal
          title={[<p style={{marginBottom: 0}}>{t(`mappingManagement.test`)}: <span style={{fontWeight: 'normal'}}>{record.name}</span></p>]}
          // closable={false}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          width="80%"
          centered
          onCancel={handleCancel}
          footer={null}
        >
          <Form ref={this.formRef} key="testForm" initialValues={{inboundFormat: 'JSON', outboundFormat: 'JSON'}}>
            <Row style={{marginBottom: 10}}>
              <Col span={24}>
                <span style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.mappingName`)}: </span>{record.name}
              </Col>
              <Col span={12}><span
                style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.inboundType`)}: </span> {record.inboundConfigInfo.type}</Col>
              <Col span={12}><span
                style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.outboundType`)}:</span> {record.outboundConfigInfo.type}</Col>
              <Col span={12}><span
                style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.inboundName`)}: </span> {record.inboundConfigInfo.name}</Col>
              <Col span={12}><span
                style={{fontSize: 14, fontWeight: 500}}>{t(`mappingManagement.outboundName`)}:</span> {record.outboundConfigInfo.name}</Col>
              <Col span={12} style={{paddingRight: 10}}>
                <Form.Item name="inboundFormat" label={t(`mappingManagement.format`)} style={{width: '50%'}}>
                  <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChange}>
                    <Select.Option key="JSON" value="JSON">JSON</Select.Option>
                    <Select.Option key="XML" value="XML">XML</Select.Option>
                  </Select>
                </Form.Item>
                <TextArea rows={8}/>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={12}>
                    <Form.Item name="outboundFormat" label={t(`mappingManagement.format`)}>
                      <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChange}>
                        <Select.Option key="JSON" value="JSON">JSON</Select.Option>
                        <Select.Option key="XML" value="XML">XML</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{textAlign: 'right'}}>
                    <Button onClick={this.handleTest} type="primary">{t(`mappingManagement.test`)}</Button>
                  </Col>
                </Row>
                <TextArea rows={8}/>
              </Col>
            </Row>
          </Form>
          <Table className="mappingTable" dataSource={toJS(versionList)} pagination={false} rowKey="id" style={{marginTop: 10}}>
            <Table.Column title={t(`mappingManagement.message`)} dataIndex="message" key="message"/>
            <Table.Column title={t(`mappingManagement.direction`)} dataIndex="direction" key="direction"/>
            <Table.Column title={t(`mappingManagement.status`)} dataIndex="status" key="status"/>
            <Table.Column title={t(`mappingManagement.step`)} dataIndex="step" key="step"/>
            <Table.Column title={t(`mappingManagement.createTime`)} dataIndex="createTime" key="createTime"/>
            <Table.Column title={t(`mappingManagement.endTime`)} dataIndex="endTime" key="endTime"/>
          </Table>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
